import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToasterService } from '@services/toaster.service';
import { environment } from '@environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { LeaveCommentsResponse } from '@interfaces/vendor-management-model';
import { TIMESHEET_CONSTANTS } from '../timesheet/timesheet.constants';

@Injectable({
  providedIn: 'root',
})
export class TimesheetCalendarService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private toasterService: ToasterService,
  ) {}

  getLeaveComments(
    employeeId: string,
    month: number,
    year: number,
  ): Observable<LeaveCommentsResponse> {
    let params = new HttpParams()
      .set('employeeId', employeeId)
      .set('month', month.toString())
      .set('year', year.toString());
    return this.http
      .get<LeaveCommentsResponse>(`${this.baseUrl}${TIMESHEET_CONSTANTS.API_ENDPOINTS.HIRING_LEAVE_COMMENTS}`, { params })
      .pipe(
        catchError((error) => {
          this.toasterService.showError(TIMESHEET_CONSTANTS.MESSAGES.FAILED_LOAD_COMMENTS, TIMESHEET_CONSTANTS.TITLES.LOAD_ERROR);
          return throwError(() => error);
        }),
      );
  }
  
  saveComment(commentData: any): Observable<any> {
    const url = `${this.baseUrl}${TIMESHEET_CONSTANTS.API_ENDPOINTS.HIRING_LEAVE_COMMENT}`;
    return this.http.post(url, commentData).pipe(
      catchError((error) => {
        this.toasterService.showError(TIMESHEET_CONSTANTS.MESSAGES.FAILED_SAVE_COMMENT, TIMESHEET_CONSTANTS.TITLES.SAVE_ERROR);
        return throwError(() => error);
      }),
    );
  }
}
